import React, { useContext, useState, useRef, useEffect } from "react";
import SlotSlider from "./slider/SlotSlider";
import LiveCashino from "./slider/LiveCashino";
import LayoutNew from "../components/shared/LayoutNew";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import AuthContext from "../context/AuthContext";
import { useTranslation } from "react-i18next";
import CurrentNews from "../components/CurrentNews";
import GameSlider from "../components/GameSlider";
import FooterSection from "../components/FooterSection";
import MainBanner from "./slider/MainBanner";
import HomeCard from "../components/home/HomeCard";
import HomeList from "../components/home/HomeList";
import {DepositWithrawDataArray} from '../Utils/variables/DepositWithrawDataArray';
import apiPath from "../Utils/apiPath";
import { apiGet } from "../Utils/apiFetch";
import { setData } from "../Utils/indexedDB";


const HomeNew = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user, setBr, lang, setEn, messagelist, setAnnouncement, amounutRefresh, refreshAmountLoader, userCoins } =
    useContext(AuthContext);
  const [show, setShow] = useState(false);

  // Dragging state
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: window.innerWidth - 80, y: window.innerHeight - 180 }); // Start at bottom right
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const spinnerRef = useRef(null);

  const handleStart = (clientX, clientY) => {
    const rect = spinnerRef.current.getBoundingClientRect();
    setDragOffset({
      x: clientX - rect.left,
      y: clientY - rect.top
    });
    setIsDragging(true);
  };

  const handleMove = (clientX, clientY) => {
    if (!isDragging) return;

    // Ensure the spinner stays within the viewport bounds
    let newX = clientX - dragOffset.x;
    let newY = clientY - dragOffset.y;

    // Keep within viewport
    newX = Math.max(0, Math.min(newX, window.innerWidth - 70));
    newY = Math.max(0, Math.min(newY, window.innerHeight - 70));

    setPosition({
      x: newX,
      y: newY
    });
  };

  const handleEnd = () => {
    setIsDragging(false);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    handleStart(e.clientX, e.clientY);
  };

  const handleMouseMove = (e) => {
    handleMove(e.clientX, e.clientY);
  };

  const handleMouseUp = () => {
    handleEnd();
  };

  const handleTouchStart = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    handleStart(touch.clientX, touch.clientY);
  };

  const handleTouchMove = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    handleMove(touch.clientX, touch.clientY);
  };

  const handleTouchEnd = () => {
    handleEnd();
  };

  useEffect(() => {
    // Update initial position when window resizes
    const updateInitialPosition = () => {
      setPosition({
        x: window.innerWidth - 80,
        y: window.innerHeight - 80
      });
    };

    window.addEventListener('resize', updateInitialPosition);
    return () => window.removeEventListener('resize', updateInitialPosition);
  }, []);

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('touchmove', handleTouchMove, { passive: false });
      document.addEventListener('touchend', handleTouchEnd);

      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
      };
    }
  }, [isDragging, dragOffset]);

  const [tabkey, setTabkey] = useState("homegame");
  const setFunc = (type) => {
    setTabkey(type);
  };
  const fetchAllSport = async () => {
    // ✅ 2. Call API in background
    try {
      const { status, data: response_users } = await apiGet(
        apiPath.matchList + `?game_type=all`
      );

      if (status === 200 && response_users.status) {
        // ✅ 3. Save in IndexedDB
        await setData("sportsData", response_users);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchAllSport();
  }, []);


  return (
    <LayoutNew>
      <MainBanner />
       <CurrentNews
        message={messagelist}
        setAnnouncement={setAnnouncement}
      />
       {/* <GameSlider /> */}
     

      <div className="main">
        <img
          ref={spinnerRef}
          onClick={() => {
            if (!isEmpty(user)) {
              navigate("/spin-wheel");

            } else {
              navigate("/login");
            }
          }}
          src="/assets/spinner.GIF"
          alt=""
          style={{
            position: 'fixed',
            left: `${position.x}px`,
            top: `${position.y}px`,
            cursor: 'grab',
            zIndex: 9999,
            width: '70px',
            height: '70px',
            userSelect: 'none',
            touchAction: 'none'
          }}
          onMouseDown={handleMouseDown}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        />


        {/* <div className="tabWrap" >
          {NavDepositWithrawData?.map((item, index) => {
            return (
              <div key={index}
                onClick={() => {
                  // if (isEmpty(user)) {
                  //   withoutLogin();
                  // } else {
                    if (!isEmpty(item?.link)) {
                      navigate(item?.link);
                    } else {
                      setFunc(item?.type);
                    }
                  // }
                }}
                className={`tab-box box ${tabkey == item?.type ? "active" : ""}`}
              >
                <figure>
                  <LazyLoadImage
                    src={ item?.icons}
                    alt=""
                
                  />
                </figure>
                <span>{item?.title}</span>
              </div>
            );
          })}
        </div>   */}
        <div className="gamehall">
          {(() => {
            switch (tabkey) {
              case 'table':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "table")} className="gT_ld"/>;
              case 'sports':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "sports")} className="gT_cricket"/>;
              case 'fish':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "fish")} className="gT_ld"/>;
              case 'slot':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "slot")} className="gT_ld"/>;                  
              case 'casino':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "casino")} className="gT_ld"/>;
              case 'arcade':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "arcade")} className="gT_ld"/>;
              case 'crash':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "crash")} className=""/>;
              default:
                return null;
            }
          })()}
        {/* {console.log(inplayCountData)} */}
        <HomeList />
        </div>


        {/* <GameSlider /> */}
        {/* <SlotSlider /> */}
        {/* <LiveCashino title="Featured Games" /> */}
        {/* <LiveCashino2 title="India Casino" /> */}
        <FooterSection />
      </div>
    </LayoutNew>
  );
};

export default HomeNew;